export enum SecurityEventLevel {
  info = 'info',
  warn = 'warn',
  error = 'error',
}

export interface IUserSecurityEvent {
  id: number;
  type: LogType;
  date: number;
  ip: string;
  level: SecurityEventLevel;
  description: string;
  targetUser: number;
  actorUser: number;
}

export enum LogType {
  Authenticate_Mobile = 'Authenticate_Mobile',
  TryAuthenticate_Mobile = 'TryAuthenticate_Mobile',
  TryAuthenticate_2fa = 'TryAuthenticate_2fa',
  Authenticate_Pass = 'Authenticate_Pass',
  Authenticate_2FA = 'Authenticate_2FA',
  Authenticate_SAC = 'Authenticate_SAC',
  Unsuccessful_Authenticate_Mobile = 'Unsuccessful_Authenticate_Mobile',
  Unsuccessful_Authenticate_Pass = 'Unsuccessful_Authenticate_Pass',
  Unsuccessful_Authenticate_2FA = 'Unsuccessful_Authenticate_2FA',
  Unsuccessful_Authenticate_SAC = 'Unsuccessful_Authenticate_SAC',
  Successful_Registration = 'Successful_Registration',
  Unsuccessful_Registration = 'Unsuccessful_Registration',
  Inconsistency = 'Inconsistency',
  Role_Add = 'Role_Add',
  Role_Remove = 'Role_Remove',
  NotifyLogout = 'NotifyLogout',
  Renew_Token = 'Renew_Token',
  User_Blocked = 'User_Blocked',
  Authorized_Security_Logs = 'Authorized_Security_Logs',
  Unauthorized_Security_Logs = 'Unauthorized_Security_Logs',
  Successful_Config = 'Successful_Config',
  Unsuccessful_Config = 'Unsuccessful_Config',
  Change_Phone = 'Change_Phone',
  Change_Password = 'Change_Password',
  User_Deleted = 'User_Deleted',
  User_Restored = 'User_Restored',
  User_Enabled = 'User_Enabled',
  User_Disabled = 'User_Disabled',
  Enable_2FA = 'Enable_2FA',
  Disable_2FA = 'Disable_2FA',
  SecurityEventView = 'SecurityEventView',
  LowDiscSpace = 'LowDiscSpace',
}
